import { render } from "./CoBrandHearthside.vue?vue&type=template&id=d64f175e&scoped=true"
import script from "./CoBrandHearthside.vue?vue&type=script&lang=js"
export * from "./CoBrandHearthside.vue?vue&type=script&lang=js"

import "./CoBrandHearthside.vue?vue&type=style&index=0&id=d64f175e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64f175e"]])

export default __exports__